import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSpacexComponent } from './simple-icons-spacex.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSpacexComponent ],
    exports:      [ SimpleIconsSpacexComponent ],
    bootstrap:    []
})
export class SimpleIconsSpacexModule {}
